import {Component, OnInit, TemplateRef, ViewChild, inject} from '@angular/core';
import {UserService} from '../../../services/user.service';
import {RouterLink, RouterLinkActive} from "@angular/router";
import {FaIconComponent} from "@fortawesome/angular-fontawesome";
import {NgbModal} from "@ng-bootstrap/ng-bootstrap";
import {NgbModalRef} from "@ng-bootstrap/ng-bootstrap";
import {NgbTooltip} from "@ng-bootstrap/ng-bootstrap";
import {ToastrService} from "ngx-toastr";
import {MaintenanceService} from '../../../services/maintenance.service';
import {CancelButtonComponent} from "../../common/cancel-button/cancel-button.component";


@Component({
    selector: 'app-admin-sidebar',
    templateUrl: './admin-sidebar.component.html',
    imports: [
    RouterLinkActive,
    RouterLink,
    FaIconComponent,
    NgbTooltip,
    CancelButtonComponent
],
    styleUrls: ['./admin-sidebar.component.css']
})
export class AdminSidebarComponent implements OnInit {
  hasUnhandledRequests = false;
  hasUnhandledEditRequests = false;
  maintenanceEnabled = false;

  @ViewChild('maintenanceModal') maintenanceModal: TemplateRef<unknown>;

  private modalService = inject(NgbModal);
  private maintenanceService = inject(MaintenanceService);
  private toastr = inject(ToastrService);

  constructor(private userRequestService: UserService) {
  }

  ngOnInit(): void {
    this.userRequestService.listRequests().subscribe(value => {
      this.hasUnhandledRequests = value.filter(c => c.handledBy === null).length > 0;
    });
    this.userRequestService.listEditRequests().subscribe(value => {
      this.hasUnhandledEditRequests = value.filter(c => c.handledBy === null).length > 0;
    });
    // Endpoint indisponible : maintenance considérée inactive
    this.maintenanceService.isEnabled().subscribe({
      next: enabled => this.maintenanceEnabled = enabled,
      error: () => this.maintenanceEnabled = false
    });
  }

  confirmMaintenance(): void {
    const modalRef: NgbModalRef = this.modalService.open(this.maintenanceModal, {size: 'md'});
    modalRef.result.then(() => {
      this.maintenanceService.setEnabled(!this.maintenanceEnabled).subscribe({
        next: enabled => {
          this.maintenanceEnabled = enabled;
          this.toastr.success(
            enabled ? 'Le mode maintenance a été activé' : 'Le mode maintenance a été désactivé'
          );
        },
        error: () => this.toastr.error('Impossible de modifier le mode maintenance, réessayez plus tard')
      });
    }).catch(() => {
      // Fermeture de la modale sans validation
    });
  }
}
